import React from 'react'
import HourGlass from './svgr/HourGlass'

const WaitingMessage = () => {
  return (
    <div className='waiting-info'>
        <div className='icon'>
            <HourGlass className="hour-glass" />
        </div>
        <h3>Getting Your Questions Ready...</h3>
        <p>We're analyzing your CSV to get everything perfectly organized. This may take a moment.</p>
    </div>
  )
}

export default WaitingMessage